import { IMetricInfo } from '../models/IMetricInfo';
import { MapperHelper } from './MapperHelper';

export module MetricMapper {

  export function map(responseList: Array<any>): IMetricInfo[]  {
    const metricList: IMetricInfo[] = [];

    for(let item of responseList){
      metricList.push(mapOne(item));
    }

    return metricList;
  }

  export function mapOne(item: any) : IMetricInfo{
    return {
      id: item.content.metricId,
      name: item.content.title,
      luid: item.content.luid,
      metricValue: item.content.value,
      metricChanged: item.content.valueChangePercent,
      contentType: item.content.type,
      viewId: item.content.viewId,
      metricViewName: item.content.viewName,
      metricUpdated: MapperHelper.toDate(item.content.lastUpdated),
      updatedAt: MapperHelper.toDate(item.content.lastModified),
      favorite: false,
      owner: {
        id: item.content.ownerId,
        displayName: item.content.ownerName,
        username: item.content.ownerName //TODO - we don't have this value
      }
    };
  }
}
